import { VtexButton } from '../../../styleguide/VtexButton';
import { useButtonState } from '../../NewsletterForm/hooks/useButtonState';
import { useNewsletterSubmit } from '../hooks/useNewsletterSubmit';

const NewsletterSubmitContainer = () => {
	const { blockClass, submitButtonLabel, componentId } = useNewsletterSubmit();
	const { setState } = useButtonState();

	const renderClass = () => {
		return blockClass && `formSubmitContainer--${blockClass}`;
	};
	return (
		<div data-selection={componentId} className={`formSubmitContainer ${renderClass()}`}>
			<VtexButton handleClick={() => setState('clicked')}>{submitButtonLabel || 'INSCREVER-SE'}</VtexButton>
		</div>
	);
};

export default NewsletterSubmitContainer;
